import { Types } from "../../actions/user/userProfile.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null
};

export default function userProfile(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.UPDATE_PROFILE: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.UPDATE_PROFILE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case Types.UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      };
    }

    case Types.UPDATE_PROFILE_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
